import { makeStyles } from 'tss-react/mui';

export const styles = makeStyles()(() => {
  return {
    tabs: {
      margin: '0 40px 16px 40px',
      borderBottom: '1px solid #E0E0E0'
    }
  };
});
